import { create } from 'zustand';

const initialState = {
  // Feature gate — org.settings.uses_veradigm_billing
  usesVeradigmBilling: false,
  // Has org completed PM setup (config exists)?
  pmConfigured: false,
  // Is integration currently active (usesVeradigmBilling AND pmConfigured AND config.is_active)?
  pmActive: false,
  // Has config been checked on app load?
  pmConfigLoaded: false,
  // Does the current user have PM credentials (or org has fallback)?
  userHasPMCredentials: false,
  // Code prefixes that post under a separate Veradigm voucher (config.separate_voucher_code_prefixes)
  separateVoucherCodePrefixes: [],
  isLoading: false,
  error: null,
};

export const useVeradigmPMStore = create((set, get) => ({
  ...initialState,

  setUsesVeradigmBilling: (enabled) => set({ usesVeradigmBilling: enabled }),

  setPMConfig: (config) => {
    const usesVeradigmBilling = get().usesVeradigmBilling;
    const hasOrgCredentials = !!(config?.pm_username);
    set({
      pmConfigured: !!config,
      pmActive: usesVeradigmBilling && !!config && config.is_active === true,
      pmConfigLoaded: true,
      // If org has credentials, user is covered even without personal ones
      userHasPMCredentials: get().userHasPMCredentials || hasOrgCredentials,
      separateVoucherCodePrefixes: config?.separate_voucher_code_prefixes || [],
    });
  },

  setUserPMCredentials: (hasCredentials) => set({ userHasPMCredentials: hasCredentials }),

  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),

  reset: () => set(initialState),
}));
